import { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { supabase } from '../lib/supabase'
import { analyseRound, getInsights, WEAKNESS_TIPS, AREA_META, MONTHS } from '../lib/analysis'
import '../styles/Results.css'

export default function Results() {
  const { id } = useParams()
  const navigate = useNavigate()
  const [round, setRound] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    supabase.from('rounds').select('*').eq('id', id).single().then(({ data }) => {
      setRound(data)
      setLoading(false)
    })
  }, [id])

  if (loading) return <div className="loading-spinner"><div className="spinner" /></div>
  if (!round) return <div className="empty-state"><h3>Round not found</h3></div>

  const { scores, worst } = analyseRound(round)
  const insights = getInsights(round, scores)
  const diff = round.score - round.par
  const diffStr = diff > 0 ? `+${diff}` : diff === 0 ? 'E' : `${diff}`
  const d = new Date(round.played_at)
  const scoreColor = diff <= 0 ? 'var(--green)' : diff <= 5 ? 'var(--yellow)' : 'var(--orange)'
  const ringPct = Math.max(5, 100 - diff * 5)

  const sortedAreas = Object.keys(scores).sort((a, b) => scores[b] - scores[a])

  return (
    <div className="results">
      <div className="results-header">
        <div className="results-score-ring" style={{ background: `conic-gradient(${scoreColor} ${ringPct}%, var(--border) 0%)` }}>
          <div className="results-score-inner">
            <div className="results-score-num" style={{ color: scoreColor }}>{diffStr}</div>
            <div className="results-score-par">vs par</div>
          </div>
        </div>
        <div className="results-title">{round.course}</div>
        <div className="results-date">{d.getDate()} {MONTHS[d.getMonth()]} · Gross {round.score} · Par {round.par}</div>
      </div>

      <div className="biggest-weakness">
        <div className="bw-label">⚠ Biggest Weakness</div>
        <div className="bw-title">{AREA_META[worst].label}</div>
        <div className="bw-text">{WEAKNESS_TIPS[worst]}</div>
      </div>

      <div className="section-title" style={{ marginBottom: 12 }}>Area Breakdown</div>
      {sortedAreas.map(key => {
        const s = scores[key]
        const cls = s >= 65 ? 'bad' : s >= 40 ? 'ok' : 'good'
        const rating = s >= 65 ? 'Poor' : s >= 40 ? 'Average' : 'Good'
        return (
          <div className={`analysis-card ${key === worst ? 'highlight' : ''}`} key={key}>
            <div className="analysis-top">
              <div className="analysis-icon">{AREA_META[key].icon}</div>
              <div>
                <div className="analysis-label">{rating}</div>
                <div className="analysis-name">{AREA_META[key].label}</div>
              </div>
              <div className="analysis-score-display">
                <div className={`analysis-pct ${cls}`}>{100 - s}</div>
                <div className="analysis-pct-label">/ 100</div>
              </div>
            </div>
            <div className="analysis-insight">{insights[key]}</div>
          </div>
        )
      })}

      <div className="results-cta-card">
        <h3>Work On Your {AREA_META[sortedAreas[0]].label}</h3>
        <p>Harry has a specific fix for this. Claim your free swing analysis — available to the first 100 Skool members only.</p>
        <a href="https://calendly.com/harryshawgolf" target="_blank" rel="noopener noreferrer" className="btn-white" style={{display:'inline-block',textDecoration:'none'}}>Book a Lesson →</a>
      </div>

      <button className="btn-secondary" style={{ width: '100%', marginTop: 8 }} onClick={() => navigate('/dashboard')}>
        ← Back to Dashboard
      </button>
    </div>
  )
}
